import React from "react";
import Slider from "rc-slider";
import Tooltip from 'rc-tooltip';
import "rc-slider/assets/index.css";

const Handle = Slider.Handle;


function pad (pad, str, padLeft) {
    if (typeof str === 'undefined')
        return pad;
    if (padLeft) {
        return (pad + str).slice(-pad.length);
    } else {
        return (str + pad).substring(0, pad.length);
    }
}

export default class SunstudyControlsMini extends React.Component {
    constructor () {
        super();

        this.state = {};

        this.onSlide = this.onSlide.bind(this);
        this.toggleShowAll = this.toggleShowAll.bind(this);
    }

    componentDidMount () {
        if (this.props.currentView) {
            this.calculateSliderValues(this.props.currentView);
        }
    }

    toggleShowAll () {
        this.props.onToggleShowAll();
    }

    calculateSliderValues (view) {
        this.setState({
            minHour: view.start_hour,
            maxHour: view.end_hour,
            nImages: view.image_count,
            hours: view.end_hour - view.start_hour + 1,
            hourStep: 100 / 24
        });
    }

    componentWillReceiveProps (nextProps) {
        //console.log(this.props);
        if (nextProps.currentView) {
            this.calculateSliderValues(nextProps.currentView);
        }
    }

    componentDidUpdate (prevProps) {
        //this.calculateSliderValues();
    }

    onViewClick (view) {
        this.props.onViewChange(view);
    }

    onSlide (n) {
        this.setState({
            currentSlide: n,
        });

        this.props.onSlide(n);
    }

    render () {
        if (!this.state.minHour) {
            return null;
        }

        let hours = this.state.maxHour - this.state.minHour;
        let step = this.state.nImages / hours;
        let currentHour = Math.round(this.props.currentSlide / (step)) + this.state.minHour;

        let cols = [];
        for (let i = 1; i <= 24; i++) {
            cols.push((<div key={i} data-time={i}
                            className={i < this.state.minHour || i > this.state.maxHour ? 'time-col disabled' : 'time-col'}>{pad('00', i, true)}</div>))
        }

        let viewButtons = this.props.sunstudy.views.data.map(view => {
            return (<button key={view.name} type="button" className={this.props.currentView === view ? 'btn btn-toggle active' : 'btn btn-toggle'}
                            onClick={() => this.onViewClick(view)}>{view.name}</button>)
        });

        const handle = (props) => {
            const {value, dragging, index, ...restProps} = props;
            return (
                <Tooltip
                    prefixCls="rc-slider-tooltip"
                    overlay={'kl ' + currentHour}
                    visible={true}
                    placement="top"
                    key={index}
                >
                    <Handle value={value} {...restProps} />
                </Tooltip>
            );
        };

        return (<div className="cw-sunstudy-controls-mini">
            <div className="cw-sunstudy-controls-mini-slider">
                <Slider min={0} max={this.state.nImages - 1} onChange={this.onSlide} value={this.props.currentSlide}
                        className="real-slider cw-sunstudy-slider" handle={handle}/>
            </div>

            <div className="cw-sunstudy-controls-mini-buttons">
                <div>
                    {this.props.backButton ?
                        <button type="button" onClick={this.props.onBack} className={'btn cw-map-back'}>
                            Översiktsbild</button> : ''
                    }
                    <button type="button" onClick={this.toggleShowAll}
                            className={this.state.showAll ? 'btn cw-map-toggle-all active' : 'btn cw-map-toggle-all'}>
                        Visa status
                    </button>
                </div>

                <div className="c-view-buttons">{viewButtons}</div>
            </div>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/components/SunstudyControlsMini.jsx